export const network = ['solana', 'https://'];